import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { AssetsResponseObject } from '@api/v4/assets/assetTypes';
import { TertiaryIconButton } from '@components/library/button/index';
import { WidgetsContext } from './widget';

const RecentlyUpdatedAssets: React.FunctionComponent = () => {
  const header = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    setHeaderHeight(header.current.offsetHeight);
  }, [headerHeight]);

  const renderAssetListItem = (asset: AssetsResponseObject): JSX.Element => (
    <li className="widgets__list--item" key={asset.id}>
      <span className="widgets__list--item-icon bff-edit" />
      <div>
        <a href={asset.attributes.best_link_for}>{asset.attributes.name}</a>
        <span className="widgets__list--item-date">{moment(asset.attributes.updated_at).format('MM/DD/YYYY')}</span>
      </div>
    </li>
  );

  return (
    <WidgetsContext.Consumer>
      {(widgetsContext): JSX.Element => widgetsContext && (
        <div className="widgets-third">
          <div ref={header} className={`widgets__header ${widgetsContext.editMode === true ? 'editing' : ''}`}>
            <h3>{widgetsContext.name}</h3>
            {widgetsContext.editMode && (
              <TertiaryIconButton
                className="widgets__edit-settings-button card-button"
                height={50}
                icon="bff-edit"
                onClick={widgetsContext.toggleForm}
                width={50}
              />
            )}
          </div>
          <ul className="widgets__list bf-scroll-element" style={{ maxHeight: `calc(700px - ${headerHeight}px)` }}>
            {(widgetsContext.widgetDataResponse && Array.isArray(widgetsContext.widgetDataResponse.data)) && widgetsContext.widgetDataResponse.data.map(
              (asset: AssetsResponseObject) => renderAssetListItem(asset)
            )}
          </ul>
        </div>
      )}
    </WidgetsContext.Consumer>
  );
};

export default RecentlyUpdatedAssets;
